import '../css/app.css';

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

// Show made by Spaceray Creative banner.
if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    var n = [
        '\n %c Made with ♥ by Spaceray Creative %c %c %c https://www.spaceraycreative.com/ \n\n',
        'color: #a0d39d; background: #0b4061; padding:5px 0;',
        'background: #4c4c4d; padding:5px 0;',
        'background: #4c4c4d; padding:5px 0;',
        'color: #fff; background: #1c1c1c; padding:5px 0;',
    ];
    window.console.log.apply(console, n);
} else
    window.console && window.console.log('Made with love ♥ by Spaceray Creative - https://www.spaceraycreative.com/');


// Font Awesome Icons
import {library, dom} from '@fortawesome/fontawesome-svg-core'
import {
    faCircle,
    faAngleRight,
    faChevronDown,
    faAngleLeft,
    faAngleUp,
    faPhone,
    faFax,
    faEnvelope,
    faMapMarkerAlt,
    faGraduationCap,
    faClipboardList,
    faAward,
    faLink
} from '@fortawesome/free-solid-svg-icons'
import {faFilePdf, faAddressCard} from '@fortawesome/free-regular-svg-icons'
import {
    faFacebook,
    faTwitter,
    faInstagram,
    faFlipboard,
    faLinkedin,
    faYoutube
} from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

library.add(faCircle, faAngleLeft, faAngleRight, faChevronDown, faAngleUp, faPhone, faFax, faEnvelope, faMapMarkerAlt, faFacebook, faTwitter, faInstagram, faFlipboard, faLinkedin, faYoutube, faGraduationCap, faAddressCard, faClipboardList, faAward, faFilePdf, faLink)

dom.watch()


// Animate On Scroll Options
// https://github.com/michalsnik/aos
import AOS from 'aos';

AOS.init({duration: 800});


// Medium Zoom plugin -- Zoom image effect on images)
// https://github.com/francoischalifour/medium-zoom
import mediumZoom from 'medium-zoom';

mediumZoom('[data-zoomable]', {
    margin: 24,
    background: '#fff',
    scrollOffset: 0,
});

